/*
 * @Author: Lzyoung
 * @Date: 2019-03-15 10:41:04
 * @Last Modified by: Lzyoung
 * @Last Modified time: 2019-03-21 10:09:00
 */

<!-- 咖啡问卷 -->
<template>
  <div class="questions-list">
    <div>
      <img
        src="../../../../assets/img/events/coffee/pic_welcome@3x.png"
        id="header-img"
      >
      <div id="questions">
        <div class="content">
          <div v-for="item in questions" :key="item.id" class="question">
            <div class="title">{{ `${item.id}.${item.title}` }}</div>
            <span
              class="answer"
              v-for="answer in item.options"
              :key="answer.id"
              :class="{ 'active' : answer.id === answers[item.id] }"
              @click="clickOption(item.id, answer.id)"
            >{{ answer.option }}</span>
          </div>
          <div class="operate">
            <span :class="['submit-button', isDisabled ? 'disabled' : '' ]" @click="submit()">提交</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getQuestions,
  submitAnswers,
  isUserDoneForSurvey,
  receiveCouponForSurvey
} from "@/common/api/events";
import { fetchAccessTokenByOpenToken } from "@/common/api/common";
import JSBridge from "@/jsbridge";
import { setToken } from "@/common/auth";
import { NOT_LOGIN_USER } from "@/common/constants";
import { Toast } from "mint-ui";

export default {
  data() {
    return {
      surveyId: "1", // 1:咖啡问卷
      questions: [],
      id: "",
      answers: {},
      isDisabled: true
    };
  },

  watch: {
    answers(val) {
      if (Object.keys(val).length === this.questions.length) {
        this.isDisabled = false;
      }
    }
  },
  beforeCreate() {
    JSBridge.Bridge.WebViewJavascriptBridge.setup();
  },
  created() {
    this.getLogin();
  },

  mounted() {
    this.initData();
  },

  methods: {
    getLogin() {
      JSBridge.Common.Caller_Common_Base_getOpenToken({}, res => {
        if (res) {
          fetchAccessTokenByOpenToken(res).then(resp => {
            let respData = resp.data;
            if (respData.code === 0) {
              setToken(respData.data.accessToken);
              this.isUserDoneForSurvey();
            }
          });
        }
      });
    },

    isUserDoneForSurvey() {
      isUserDoneForSurvey({
        surveyId: this.surveyId
      }).then(resp => {
        let data = resp.data.data;
        if (data.done) {
          this.$router.push({ path: "/events/coffee/submitted" });
        }
      });
    },

    back() {
      this.$router.push({ path: "/delicacy/" });
    },

    initData() {
      getQuestions(this.surveyId).then(resp => {
        let data = resp.data.data.data;
        this.questions = data.questions;
      });
    },

    clickOption(questionId, answerId) {
      this.$set(this.answers, questionId, answerId);
    },

    submit() {
      let answers = [];
      if (!this.isDisabled) {
        for (let questionId in this.answers) {
          answers.push({
            questionId,
            optionId: this.answers[questionId],
            others: ""
          });
        }
        submitAnswers({
          surveyId: this.surveyId,
          answers
        }).then(resp => {
          if (resp.data.code === 0) {
            receiveCouponForSurvey({ surveyId: this.surveyId }).then(() => {
              this.$router.push({ path: "/events/coffee/submitted" });
            });
          } else if (resp.data.code === NOT_LOGIN_USER) {
            this.getLogin();
          } else {
            Toast(resp.data.msg);
          }
        });
      }
    }
  }
};
</script>
<style lang='scss'>
@import "../../../../assets/css/px2rem.scss";
.questions-list {
  #header-img {
    width: 100%;
  }
  #questions {
    padding: px2rem(30);
    background: #fff;
  }
  .question {
    font-size: px2rem(14);
    margin-bottom: px2rem(50);
    .title {
      color: #333333;
      margin-bottom: px2rem(20);
    }
    .answer {
      display: inline-block;
      padding: 0 px2rem(16);
      height: px2rem(26);
      line-height: px2rem(26);
      color: #666666;
      border: px2rem(0.5) solid #999999;
      margin-right: px2rem(30);
    }
    .active {
      background: #ffeeec;
      border: px2rem(0.5) solid #f06050;
      color: #f06050;
    }
  }
  .operate {
    text-align: center;
    font-size: px2rem(14);
    .submit-button {
      display: inline-block;
      width: px2rem(120);
      height: px2rem(34);
      line-height: px2rem(34);
      background: #f06050;
      color: #fff;
    }
    .disabled {
      background: #dddddd !important;
    }
  }
}
.mint-toast.is-placemiddle {
  padding: px2rem(10) !important;
  .mint-toast-text {
    font-size: px2rem(14);
  }
}
</style>
